import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchTitulos, deleteTitulo } from '../actions/titulosActions';
import { fetchGrados } from '../actions/gradoActions';
import { fetchUniversidades } from '../actions/universidadActions';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { toast } from 'react-toastify';
import TitulosForm from './TitulosForm';
import { Modal, Button, Table } from 'react-bootstrap';

// Estilos CSS para la tabla
const tableStyles = {
  tableLayout: 'fixed', // Forzar el ancho de las columnas
  width: '100%', // Asegurar que la tabla ocupe el 100% del contenedor
};

const cellStyles = {
  overflow: 'hidden', // Evitar que el contenido desborde
  textOverflow: 'ellipsis', // Mostrar "..." si el contenido es demasiado largo
  whiteSpace: 'nowrap', // Evitar saltos de línea
};

const TitulosList = ({ showTitulosModal, closeTitulosModal, socio }) => {
  const [confirmDeleteModal, setConfirmDeleteModal] = useState(false);
  const dispatch = useDispatch();

  const { titulos, loading, error } = useSelector(state => state.titulo);
  const { grados } = useSelector(state => state.grado);
  const { universidades } = useSelector(state => state.universidad);

  const [showFormModal, setShowFormModal] = useState(false);
  const [titulo, setTitulo] = useState({
    nombre: '',
    descrip: '',
    grado: '',
    univor: '',
    fechor: new Date(),
    univrev: '',
    fechrev: new Date(),
    fechapos: new Date(),
    documpdf: '',
    idcodreg: socio ? socio.id : ''
  });
  const [tituloToDelete, setTituloToDelete] = useState(null);

  useEffect(() => {
    if (socio && socio.id) {
      dispatch(fetchTitulos(socio.id));
    }
    dispatch(fetchGrados());
    dispatch(fetchUniversidades());
  }, [dispatch, socio]);

  const getGradoNombre = (id) => {
    const grado = grados.find(grado => grado.id === id);
    return grado ? grado.nombre : 'Desconocido';
  };

  const getUniversidadNombre = (id) => {
    const universidad = universidades.find(univ => univ.id === id);
    return universidad ? universidad.nombre : 'Desconocida';
  };

  const closeFormModal = (updated) => {
    setShowFormModal(false);
    if (updated && socio && socio.id) {
      dispatch(fetchTitulos(socio.id));
    }
  };

  const createNew = () => {
    setTitulo({
      nombre: '',
      descrip: '',
      grado: '',
      univor: '',
      fechor: null,
      univrev: '',
      fechrev: null,
      fechapos: null,
      documpdf: '',
      idcodreg: socio ? socio.id : ''
    });
    setShowFormModal(true);
  };

  const confirmDeleteHandler = (id) => {
    setTituloToDelete(id);
    setConfirmDeleteModal(true);
  };

  const handleDelete = async () => {
    setConfirmDeleteModal(false);
    if (tituloToDelete) {
      try {
        await dispatch(deleteTitulo(tituloToDelete));
        toast.success('Título eliminado correctamente');
        if (socio && socio.id) {
          dispatch(fetchTitulos(socio.id));
        }
      } catch (error) {
        toast.error(`Error al eliminar título: ${error.message}`);
      }
    }
  };

  const modificar = (data) => {
    setTitulo(data);
    setShowFormModal(true);
  };

  if (loading) return <div>Cargando títulos...</div>;
  if (error) return <div>Error al cargar los datos: {error}</div>;

  return (
    <>
      <Modal show={showTitulosModal} onHide={closeTitulosModal} backdrop="static" keyboard={false} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Listado de Títulos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {socio && (
            <div className="row">
              <div className="col-3">
                <p><strong>Código de Registro:</strong></p>
                <p><strong>Apellido Paterno:</strong></p>
                <p><strong>Apellido Materno:</strong></p>
                <p><strong>Nombres:</strong></p>
              </div>
              <div className="col-5">
                <p>{socio.codreg}</p>
                <p>{socio.apPat}</p>
                <p>{socio.apMat}</p>
                <p>{socio.nombres}</p>
              </div>
              <div className="col-4 text-end">
                <button onClick={() => createNew()} className="button btn-accent float-end">
                  <i className="bi bi-plus-lg"></i> Agregar Título
                </button>
              </div>
            </div>
          )}
          <div className="table-container mt-3">
            <Table hover striped bordered responsive style={tableStyles}>
              <thead>
                <tr>
                  <th style={{ width: '20%', ...cellStyles }}>Nombre</th>
                  <th style={{ width: '20%', ...cellStyles }}>Descripción</th>
                  <th style={{ width: '15%', ...cellStyles }}>Grado</th>
                  <th style={{ width: '25%', ...cellStyles }}>Universidad Origen</th>
                  <th style={{ width: '10%', ...cellStyles }}>Fecha Origen</th>
                  <th style={{ width: '10%', ...cellStyles }}>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {titulos.map(titulo => (
                  <tr key={titulo.id}>
                    <td style={{ width: '20%', ...cellStyles }}>{titulo.nombre}</td>
                    <td style={{ width: '20%', ...cellStyles }}>{titulo.descrip}</td>
                    <td style={{ width: '15%', ...cellStyles }}>{getGradoNombre(titulo.grado)}</td>
                    <td style={{ width: '25%', ...cellStyles }}>{getUniversidadNombre(titulo.univor)}</td>
                    <td style={{ width: '10%', ...cellStyles }}>{new Date(titulo.fechor).toLocaleDateString()}</td>
                    <td style={{ width: '10%', ...cellStyles }}>
                      <div className="action-buttons d-flex justify-content-between">
                        <button onClick={() => modificar(titulo)} className="button btn-accent-outline pt-1">
                          <i className="bi bi-pencil"></i>
                        </button>
                        <button onClick={() => confirmDeleteHandler(titulo.id)} className="btn btn-outline-danger pt-1">
                          <i className="bi bi-trash"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
          <button className="button btn-cancel" onClick={closeTitulosModal}>
            <i className="bi bi-arrow-left"></i> Volver
          </button>
        </Modal.Body>
      </Modal>

      {socio && (
        <TitulosForm showFormModal={showFormModal} closeFormModal={closeFormModal} titulo={titulo} socio={socio} />
      )}
      <Modal show={confirmDeleteModal} onHide={() => setConfirmDeleteModal(false)} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Confirmar eliminación</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>¿Estás seguro de que deseas eliminar este título?</p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setConfirmDeleteModal(false)}>No</Button>
          <Button variant="danger" onClick={handleDelete}>Sí</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default TitulosList;